import UserFilesPage from '@/user_files/UserFilesPage'
import { UserFilesFolderRouteHandler } from '@/user_files/folders/components/UserFilesFolderRouteHandler'
import { FilesExperienceRedirect } from './filesExperienceRedirect'
import type { RouteFactory } from '@/routing/types'

/**
 * Creates user files routes for nesting under MatterLayout.
 * URL pattern: /dashboard/m/:matterId/user-files/:folderId?
 *
 * The optional :folderId? parameter allows deep-linking to specific folders:
 * - /dashboard/m/:matterId/user-files → Shows the matter's root folder
 * - /dashboard/m/:matterId/user-files/:folderId → Shows the specified folder
 *
 * Note: Authentication is handled by MatterLayout's AnonFeatureGuard,
 * so no additional AnonymousGuard wrapper is needed here.
 *
 * @see MatterLayout for parent route context
 * @see UserFilesFolderRouteHandler for URL → Redux state synchronization
 */
export const createUserFilesChildRoutes: RouteFactory = () => [
  {
    // Redirects to the legacy drive when the new files UX is off (also covers Haiku); renders user files otherwise.
    element: <FilesExperienceRedirect experience="new" />,
    children: [
      {
        path: 'user-files/:folderId?',
        element: (
          <UserFilesFolderRouteHandler>
            <UserFilesPage />
          </UserFilesFolderRouteHandler>
        ),
      },
    ],
  },
]
